/**
 * @generated SignedSource<<4d66e0e19412f0cf1d33f636102d33f5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMarketSettings_viewer$data = {
  readonly isNftAuctionV2Enabled: boolean | null;
  readonly " $fragmentType": "useMarketSettings_viewer";
};
export type useMarketSettings_viewer$key = {
  readonly " $data"?: useMarketSettings_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMarketSettings_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useMarketSettings_viewer",
  "selections": [
    {
      "alias": "isNftAuctionV2Enabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftAuctionV2"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1577571309b7108580e4d227e186a175";

export default node;
